export const locales = {
  "English": "EN",  
  "Italiano": "IT-IT",
  "Deutsch": "DE-DE",
  "日本語": "JA-JP",
  "Español": "ES-MX",
  "Português": "PT-BR",
  "中文(简体)": "ZH-CN",
  "Français": "FR-FR",
};